// extracted by mini-css-extract-plugin
module.exports = {"container":"OrdersSkeleton_container__vI96H","row":"OrdersSkeleton_row__NaFwh","ordersContainer":"OrdersSkeleton_ordersContainer__nyr27"};